import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { LiveCasinoPageMainWrapper } from './LiveCasinoPage.style';
import { LiveCasinoRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { CasinoCollection } from 'src/domains/casino/webview/CasinoGames/CasinoCollection';
import { useCommon } from 'src/domains/common/Common';

interface PropsType {
    currentView: LiveCasinoRouteType;
    accountView: RightHandSideViewType | null;
    isSearchActive: boolean;
}

export const LiveCasinoPage = observer('LiveCasinoPage', (props: PropsType) => {
    const common = useCommon();
    const { currentView, isSearchActive, accountView } = props;
    const appCasinoState = AppCasinoState.get(common);

    return (
        <LiveCasinoPageMainWrapper data-test='live-casino-page'>
            <LayoutSkeleton
                navigation={false}
                accountView={accountView}
                currentView={currentView}
                isSearchActive={isSearchActive}
                navigationType='live-casino'
            >
                <CasinoCollection
                    appCasinoState={appCasinoState}
                    collection='live-casino'
                    tabId={currentView.tabId ?? null}
                />
            </LayoutSkeleton>
        </LiveCasinoPageMainWrapper>
    );
});
